// extracted by mini-css-extract-plugin
export var boxItems = "_86-1";
export var boxItemsLg = "_86-2";
export var button = "_86-7";
export var buttonHoverless = "_86-9";
export var buttonLg = "_86-8";
export var filterGroupBox = "_86-0";
export var icon = "_86-3";
export var iconSecondary = "_86-6";
export var iconWrapper = "_86-4";
export var iconWrapperLg = "_86-5";
export var truncatedLabel = "_86-a";